const de = {
  title: 'International Office',
  manageUsers: 'Benutzerverwaltung',
  manageCourses: 'Kursverwaltung',
  manageEvents: 'Eventverwaltung',
  myCourses: 'Meine Kurse',
  myEvents: 'Meine Events',
  coursesTitleLong: 'Kursregistrierung',
  coursesTitle: 'Kurse',
  eventsTitleLong: 'Veranstaltungsanmeldung',
  eventsTitle: 'Events',
  users: {
    homeUniversity: 'Heimatuniversität',
    courseOfStudies: 'Studiengang',
    semester: 'Semester',
    newIOUser: 'Neuer International Office Benutzer',
    editIOUser: 'International Office Benuter Bearbeitung',
    search: 'Suche',
    alerts: {
      error: {
        loadingUsers: 'Benutzer konnten nicht geladen werden.',
        creatingUser: 'Neuer Benutzer konnte nicht angelegt werden.',
        checkingEmail: 'Die Email konnte nicht getestet werden.',
        updatingUser: 'Benutzer konnte nicht bearbeitet werden.',
        deletingUser: 'Benutzer konnte nicht gelöscht werden.'
      },
      success: {
        createdUser: 'Neuer Benutzer wurde erfolgreich angelegt.',
        updatedUser: 'Benutzer wurde erfolgreich bearbeitet.',
        deletedUser: 'Benutzer wurde erfolgreich gelöscht.'
      }
    },
    deleteConfirm: {
      title: 'Wirklich löschen?',
      message: 'Wollen Sie wirklich diesen Benutzer löschen?'
    }
  },
  courses: {
    newIOCourse: 'Neuer International Office Kurs',
    editIOCourse: 'International Office Kurs Bearbeitung',
    facultyReport: 'Fakultäten Report',
    officersReport: 'Kontakt Report',
    reports: 'Reports',
    orderNumber: 'Priorität',
    faculty: 'Fakultät',
    courseName: 'Kurs',
    courseNumber: 'Code',
    courseDescription: 'Datei',
    courseOfficer: 'Kontakt',
    semester: 'Semester',
    isWinter: 'Winter',
    isSummer: 'Sommer',
    isAWPM: 'Wahlmodule',
    isAWPMHeader: 'Wahlmodul',
    AWPM: 'AWPM',
    FWPM: 'FWPM',
    type: 'Typ',
    ects: 'ECTS-Credits',
    degree: 'Grad',
    enroll: 'Eintragen',
    unenroll: 'Austragen',
    notAvailable: 'nicht verfügbar in aktuellem semester',
    alerts: {
      error: {
        loadingCourses: 'Kurse konnten nicht geladen werden.',
        creatingCourse: 'Neuer Kurs konnte nicht angelegt werden.',
        updatingCourse: 'Kurs konnte nicht bearbeitet werden.',
        deletingCourse: 'Kurs konnte nicht gelöscht werden.',
        savingCourseCode: 'Es existiert bereits ein Kurs mit diesem Code',
        savingCourseDescription: 'Kursbeschreibung konnte nicht gespeichert werden.',
        enrollingCourse: 'Fehler beim Eintragen in den Kurs.',
        unenrollingCourse: 'Fehler beim Austragen von dem Kurs.'
      },
      success: {
        createdCourse: 'Neuer Kurs wurde erfolgreich angelegt.',
        updatedCourse: 'Kurs wurde erfolgreich bearbeitet.',
        deletedCourse: 'Kurs wurde erfolgreich gelöscht.',
        enrolledCourse: 'Sie haben sich erfolgreich in den Kurs eingetragen.',
        unenrolledCourse: 'Sie haben sich erfolgreich von dem Kurs ausgetragen.'
      }
    },
    deleteConfirm: {
      title: 'Wirklich löschen?',
      message: 'Wollen Sie wirklich diesen Kurs löschen?'
    }
  },
  events: {
    newIOEvent: 'Neues International Office Event',
    eidtIOEvent: 'International Office Event Bearbeitung',
    eventsReport: 'Events Report',
    organisersReport: 'Events Veranstalter-Report',
    orderNumber: 'Priorität',
    eventName: 'Event',
    dateAndTime: 'Datum und Uhrzeit',
    date: 'Datum',
    eventDescription: 'Beschreibung',
    participants: 'Teilnehmer',
    costs: 'Kosten',
    registrationDeadline: 'Anmeldeschluss',
    meetingPoint: 'Treffpunkt',
    eventOfficer: 'Verantwortliche Person',
    contact: 'Kontakt',
    actions: 'Aktionen',
    participantsTypes: {
      ALL_INTERNATIONAL_STUDENTS: 'All International Students',
      EXCHANGE_STUDENTS: 'Exchange Students',
      MASTER_INTERNATIONAL_STUDENTS: 'Master International Students'
    },
    alerts: {
      error: {
        loadingEvents: 'Events konnten nicht geladen werden.',
        creatingEvent: 'Neues Event konnte nicht angelegt werden.',
        updatingEvent: 'Event konnte nicht bearbeitet werden.',
        deletingEvent: 'Event konnte nicht gelöscht werden.',
        savingCourseDescription: 'Eventbeschreibung konnte nicht gespeichert werden.',
        enrollingEvent: 'Fehler beim Eintragen in das Event.',
        unenrollingEvent: 'Fehler beim Austragen von dem Event.'
      },
      success: {
        createdEvent: 'Neues Event wurde erfolgreich angelegt.',
        updatedEvent: 'Event wurde erfolgreich bearbeitet.',
        deletedEvent: 'Event wurde erfolgreich gelöscht.',
        enrolledEvent: 'Sie haben sich erfolgreich in das Event eingetragen.',
        unenrolledEvent: 'Sie haben sich erfolgreich von dem Event ausgetragen.'
      }
    },
    deleteConfirm: {
      title: 'Wirklich löschen?',
      message: 'Wollen Sie wirklich dieses Event löschen?'
    }
  }
};

export default de;
export type IOTranslation = typeof de;
